import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';
import { StyledTypographyColorSectionNavLinkMainMedium } from 'components/StyledTypographyColorSectionNavLinkMainMedium';

const StyledTypography = styled(StyledTypographyColorSectionNavLinkMainMedium)({
  textTransform: 'uppercase',
  fontSize: 12,
  letterSpacing: 2
});

const OrderSettingsDetailHeader = ({ title, name, description }) => {
  const styles = { variant: MENU_ITEM_NAMES };

  return (
    <React.Fragment>
      <Box mb={0.25}>
        <StyledTypography {...styles}>{title}</StyledTypography>
      </Box>
      <Typography variant="h1">{name}</Typography>
      <Box mt={1} mb={0.5}>
        <Typography>{description}</Typography>
      </Box>
    </React.Fragment>
  );
};

OrderSettingsDetailHeader.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string
};

export default OrderSettingsDetailHeader;
